import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';

export const fetchAdminBillingAccountOrganization = async (
  call: TCall,
  billingAccountId: string,
  signal: AbortSignal,
) => {
  const result = await call(() =>
    cancelOnSignal(AdminService.getAdminOrganizationByBillingAccount({ billingAccountId }), signal),
  );
  if (!result.organization) {
    throw new Error('Billing account organization is missing');
  }
  return result.organization;
};
